const getValuesFromMultiSelect = (categories: any) => {
  const categoryValues: any = [];
  categories.map((x: any) => categoryValues.push(x.value));
  return categoryValues;
};

export default getValuesFromMultiSelect;
